import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Without this, editing any slice has no Fast Refresh boundary above it (store.ts -> main.tsx are
// not components), so Vite falls back to a full page reload. Swapping the reducer keeps the store
// instance - and everything injected with injectStore() - intact.
if (import.meta.hot) {
    import.meta.hot.accept('./rootReducer', (newModule) => {
        if (newModule?.default) {
            store.replaceReducer(newModule.default);
        }
    });
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
